export default defineNuxtPlugin( ( nuxtApp ) => {
  const errorsState = useState<any[]>( "errors", () => [] );
  const { enabled } = useDebugMode();

  nuxtApp.hook( "vue:error", ( err: unknown ) => {
    if ( enabled.value ) {
      errorsState.value.push( err );
    }
  } );
} );
